app.controller("tessituraCtrl", [
  "$scope",
  "$location",
  "$http",
  "config",
  "$routeParams",
  "$localStorage",
  "$sce",
  "$q",
  "DTOptionsBuilder",
  "DTColumnBuilder",
  "$compile",
  "checkUser",
  "$interval",
  "$rootScope",
  function (
    $scope,
    $location,
    $http,
    config,
    $routeParams,
    $localStorage,
    $sce,
    $q,
    DTOptionsBuilder,
    DTColumnBuilder,
    $compile,
    checkUser,
    $interval,
    $rootScope
  ) {
    let microsite = JSON.parse($localStorage.microsite);
    let siteConfig = microsite.microsite;

    if (siteConfig.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    $scope.show = "loading";
    $scope.companionUrl = null;

    let customerId = $routeParams.customerId;
    let contentId = $routeParams.contentId;

    var pageSize = 10;
    if (siteConfig.pageSize !== undefined) pageSize = siteConfig.pageSize;

    let error_message = " ";
    if (siteConfig.customErrorMessage != "--")
      error_message = siteConfig.customErrorMessage;

    var data;
    var production = $location.path().search("prod") > -1; //tessitura prod used for TAB
    var psid = $location.path().search("psid") > -1; //production_season used for ACM
    var tsoc = $location.path().search("tsoc") > -1; //tess order customer used for TWC
    var tsocplay = $location.path().search("tsocplay") > -1; //tess order used for TSO

    if (production) {
      data = {
        siteID: siteConfig.siteID,
        platform: "tessitura",
        contentID: $routeParams.contentId,
        prod_season_no: $routeParams.prod_season_no,
        ticket_no: $routeParams.ticket_no,
      };
    } else if (psid) {
      data = {
        siteID: siteConfig.siteID,
        platform: "tessitura",
        contentID: $routeParams.contentId,
        prod_season_no: $routeParams.prod_season_no,
        order_no: $routeParams.order_no,
      };
    } else if (tsoc) {
      data = {
        siteID: siteConfig.siteID,
        platform: "tessitura",
        contentID: $routeParams.contentId,
        order_no: $routeParams.order_no,
        customerID: $routeParams.customer_no,
      };
    } else if (tsocplay) {
      data = {
        siteID: siteConfig.siteID,
        platform: "tessitura",
        contentID: $routeParams.contentId,
        order_no: $routeParams.order_no,
        customerID: $routeParams.customer_no,
      };
    } else {
      data = {
        siteID: siteConfig.siteID,
        platform: "tessitura",
        contentID: contentId,
        customerID: customerId,
      };
    }

    function validateTessitura() {
      let q = $q.defer();
      $http({
        method: "POST",
        url: config.fstreamAPI + "thirdPartyAccess",
        headers: {
          "Content-Type": "application/json", //x-www-form-urlencoded
          Accept: "application/json",
        },
        data: data,
      }).then(
        function onSuccess(response) {
          var responseData = response.data.data;
          if (response.data.message == "golden") {
            //golden ticket so no concurrency checks
            $interval.cancel($rootScope.checkDoubleLoginInterval);
          }
          if (tsocplay) {
            getContent($routeParams.child_contentId, responseData.devices).then(
              function (res) {
                q.resolve(res);
              }
            );
          } else {
            q.resolve(responseData);
          }
        },
        function onError(response) {
          q.reject(false);
        }
      );
      return q.promise;
    }

    function getContent(id, devices) {
      let q = $q.defer();

      $http({
        method: "GET",
        url: config.fstreamAPI + "getContentByID/" + id,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: apiKey,
        },
        data: data,
      }).then(
        function onSuccess(res) {
          var resData = res.data.data[0];
          resData.devices = devices;
          $routeParams.contentId = id;
          q.resolve(resData);
        },
        function onError(response) {
          q.reject(false);
        }
      );
      return q.promise;
    }

    function invalidateSession() {
      $http({
        method: "DELETE",
        url: `${config.fstreamAPI}tessitura/invalidateSession`,
      }).catch((err) => console.error(err));
    }

    function populateSub() {
      $scope.dtOptions = DTOptionsBuilder.newOptions()
        .withOption("ajax", {
          xhrFields: {
            withCredentials: true,
          },
          url: `${config.fstreamAPI}tessitura/contentSubscription`,
          type: "GET",
          error: function (xhr, error, status) {
            console.log(error);
          },
          data: function (d) {
            d.playlistID = contentId;
          },
        })
        .withDataProp("data")
        .withOption("processing", true)
        .withOption("serverSide", true)
        .withOption("searchDelay", 1500)
        .withOption("responsive", false)
        .withOption("createdRow", function (row, data, dataIndex) {
          $compile(angular.element(row).contents())($scope);
        })
        .withOption("initComplete", function (settings, json) {
          $("#dtMaterialDesignExample_wrapper")
            .find("label")
            .each(function () {});
          $("#dtMaterialDesignExample_wrapper .dataTables_filter")
            .find("input")
            .each(function () {
              const $this = $(this);
            });
          $("#dtMaterialDesignExample_wrapper").removeClass("form-inline");
        })
        .withPaginationType("full_numbers")
        .withDisplayLength(pageSize);

      $scope.dtColumns = [
        DTColumnBuilder.newColumn("contentID")
          .withTitle("ID")
          .notSortable()
          .withClass("hiddencol d-none d-sm-table-cell"),
        DTColumnBuilder.newColumn(null)
          .withTitle("")
          .withOption("searchable", false)
          .renderWith(posterImage)
          .withClass("d-none d-sm-table-cell")
          .notSortable(),
        DTColumnBuilder.newColumn(null)
          .withTitle("")
          .renderWith(checkStart)
          .withOption("searchable", false)
          .notSortable(),
        DTColumnBuilder.newColumn(null)
          .withTitle("")
          .withOption("searchable", false)
          .renderWith(playIt)
          .notSortable(),
      ];
    }

    function initPlayer(content) {
      let contentOwnerID = content.userID;
      if (contentOwnerID !== siteConfig.userID) {
        $scope.show = "error";
        $scope.errorHeader = "Video unavailable.";
        $scope.errorDesc = error_message;
      }

      $scope.contentInfo = content;

      $scope.descriptionIframe = null;
      $scope.playerTopContent = null;
      let playerType = "";

      if (Array.isArray(content.metadata)) {
        for (let metadata of content.metadata) {
          //to the right of the player
          if (metadata.mkey === "companionURL") {
            $scope.companionUrl = $sce.trustAsResourceUrl(
              metadata.metadataText
            );
          }
          //allows something in an iframe below the player
          if (metadata.mkey === "descriptionIframe") {
            $scope.descriptionIframe = $sce.trustAsResourceUrl(
              metadata.metadataText
            );
          }
          if (
            metadata.mkey === "playerType" &&
            metadata.metadataText === "bm"
          ) {
            playerType += "&bm=1";
          }
          if (
            metadata.mkey === "countdown" &&
            metadata.metadataText === "hide"
          ) {
            playerType += "&countdown=false";
          }
          if (metadata.mkey === "playerTopContent") {
            //as the name says
            $scope.playerTopContent = $sce.trustAsResourceUrl(
              metadata.metadataText
            );
          }
        }
      }

      $http({
        method: "GET",
        url: `${config.fstreamAPI}getThirdPartyPlayer/${$routeParams.contentId}`,
        headers: {
          "Content-Type": "application/json", //x-www-form-urlencoded
          Accept: "application/json",
        },
      }).then(
        function success(res) {
          const playerUrl = res.data.url;
          $scope.access = true;
          $scope.iframeURL = $sce.trustAsResourceUrl(
            playerType ? `${playerUrl}${playerType}` : playerUrl
          );
        },
        function error(res) {
          $scope.access = true;
          $("#noAccess").show();
        }
      );
    }

    validateTessitura().then(
      function (content) {
        $scope.title = content.title;
        $localStorage.forcePasswordChange = false;

        if ($routeParams.ticket_no != undefined)
          $localStorage.shopUserID = $routeParams.ticket_no;

        if ($routeParams.order_no != undefined) {
          var microsite = JSON.parse($localStorage.microsite);
          microsite.microsite.concurrentUsers = content.devices; //new concurrent users fed from API

          $localStorage.shopUserID = $routeParams.order_no;
        }

        if ($routeParams.customerId != undefined) {
          var microsite = JSON.parse($localStorage.microsite);
          microsite.microsite.concurrentUsers = content.devices; //new concurrent users
          $localStorage.microsite = JSON.stringify(microsite);

          $localStorage.shopUserID = $routeParams.customerId;
        }

        let newUuid = checkUser.getUUID();
        checkUser.setBucketUuids(newUuid);

        if (content.contentTypeID == "13" || content.contentTypeID == "15") {
          populateSub();
          $scope.show = "sub";
        } else {
          $scope.show = "play";
          $scope.access = true;
          initPlayer(content);
        }
      },
      function (error) {
        invalidateSession();
        $localStorage.$reset();
        $interval.cancel($rootScope.checkDoubleLoginInterval);
        $scope.show = "error";
        $scope.errorHeader = "Video unavailable.";
        $scope.errorDesc = error_message;
      }
    );

    function checkStart(data, type, full, meta) {
      if (data.start > 0) {
        var nowDate = new Date();
        var now = nowDate.getTime() / 1000;

        if (data.start < now && data.end > now) {
          return (
            "<strong>" +
            data.title +
            "</strong><br><small class='text-info'>Live now</small>"
          );
        }
        if (data.start < now && data.end < now) {
          return (
            "<strong>" +
            data.title +
            "</strong><br><small class='text-info'>Stream Complete</small>"
          );
        }
        if (data.start > now) {
          return (
            "<strong>" +
            data.title +
            "</strong><br><small class='text-info'>" +
            moment.unix(data.start).format("LLLL") +
            "</small>"
          );
        }
      }

      return (
        "<strong>" +
        data.title +
        "</strong><br><small class='text-info'>Available now</small>"
      );
    }

    function playIt(data, type, full, meta) {
      var nowDate = new Date();
      var now = nowDate.getTime() / 1000;

      let linkUrl;
      let isDisabled = false;

      linkUrl = `#/tsocplay/${$routeParams.contentId}/${$routeParams.order_no}/${$routeParams.customer_no}/${data.contentID}`;

      if ($routeParams.order_no === undefined) {
        linkUrl = `#/tessitura/${data.contentID}/${customerId}`;
      }

      if (data.end < now && data.end != 0) {
        linkUrl = "";
        isDisabled = true;
      }

      return `<a href="${linkUrl}" class="btn btn-success btn-sm" ${
        !isDisabled ? "disabled" : ""
      } type="button"><i class="fa fa-play"></i></a>`;
    }

    function posterImage(data, type, full, meta) {
      return '<img src="https://' + data.poster + '" width="100" loading="lazy">';
    }

    let darkmode = false;
    $scope.darkmode = function () {
      if (darkmode) {
        $("#darkmodeBtn").addClass("btn-primary");
        $("#darkmodeBtn").removeClass("btn-dark");
        $("#darkmodeBtn").text("Dark Mode");
        $("#overlay").hide();
        darkmode = false;
      } else {
        $("#darkmodeBtn").addClass("btn-dark");
        $("#darkmodeBtn").removeClass("btn-primary");
        $("#darkmodeBtn").text("Light Mode");
        $("#overlay").show();
        darkmode = true;
      }
    };
  },
]);
